import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {COMMAND_PRIORITY_LOW, INSERT_LINE_BREAK_COMMAND, INSERT_PARAGRAPH_COMMAND} from 'lexical';

import {useRef} from 'react';

import {useOnMount} from 'shared/web';

export const NoParagraphPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const unregister = useRef<VoidFunction | null>(null);

  useOnMount(
    () => {
      unregister.current = editor.registerCommand(
        INSERT_PARAGRAPH_COMMAND,
        (_payload, editor) => {
          editor.dispatchCommand(INSERT_LINE_BREAK_COMMAND, false);
          return true;
        },
        COMMAND_PRIORITY_LOW
      );
    },
    () => unregister.current?.()
  );

  return null;
};
